import styled from '@emotion/styled';
import { shouldForwardProp } from '@/utils/style.utils';
import { css } from '@emotion/react';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const HeaderWrapper = styled('div', { shouldForwardProp })<{ $multipleAirlines: boolean }>`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  gap: ${({ $multipleAirlines }) => ($multipleAirlines ? '4px' : '16px')};
  min-width: 128px;
  max-width: 128px;
`;

const TimeStopsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

const AirportWrapper = styled.div`
  margin: 0px;
  display: flex;
  align-items: center;
`;

const Duration = styled.div`
  flex-grow: 1;
  margin: 0px 16px;
  justify-content: center;
  display: flex;
  padding-inline-end: 8px;
`;

const LegInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-inline: 24px 40px;
`;

const CarrierName = styled('span', { shouldForwardProp })<{ $includeComma: boolean }>`
  ${({ $includeComma }) =>
    $includeComma &&
    `
      &:after {
        content: ',';
      }
  `}
`;

const Title = styled('div', { shouldForwardProp })<{ $multipleAirlines: boolean }>`
  display: flex;
  width: 78px;
  max-height: 32px;

  & > .MuiTypography-root {
    width: 78px;
    height: fit-content;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-break: break-word;
  }

  ${({ $multipleAirlines }) =>
    $multipleAirlines &&
    css`
      width: 72px;
      & > .MuiTypography-root {
        height: 32px;
        width: 54px;
      }
    `}
`;

const BaggageIcon = styled.div`
  margin-inline-end: 16px;
`;

export default {
  Wrapper,
  HeaderWrapper,
  Title,
  AirportWrapper,
  Duration,
  TimeStopsWrapper,
  LegInfo,
  Header,
  CarrierName,
  BaggageIcon,
};
